import Swal from 'sweetalert2';

class BraneyPopup {
    constructor(option) {
        if (option.icon && option.icon == "success"){
            this.icon  = option.icon;
            this.title = option.title;
            this.description = option.text;
            this.button = option.button;
            this.renderPopupSuccess();
        }
        else {
            Swal.fire(option)
        }
    }

    renderPopupSuccess() {
        const html = `
            <div class="popup-success is-showed popup fixed z-[99999] inset-0 bg-black-500 items-center justify-center hidden [&amp;.is-showed]:flex animate-opacity">
                <div class="close absolute inset-0 w-full h-full"></div>
                <div class="relative z-1 max-w-[92vw]">
                    <div class="relative mx-auto w-w808p popup-wrapper max-h-[94vh] bg-white overflow-auto lg:rounded-w20p rounded-w10p">
                    <div class="w-full h-full duration-500">
                        <div class="w-full lg:px-w30p lg:py-w60p px-w20p py-w30p">
                        <div class="w-auto relative lg:pb-w9p pb-w4p"><span class="absolute bottom-0 left-1/2 -translate-x-1/2 lg:w-w180p w-w110p shrink-0 border-b-3p border-line-base rounded-w10p pointer-events-none select-none"></span>
                            <p class="text-shadow-yellow lg:text-32p lg:leading-w50p text-20p leading-w39p font-bold text-main text-center"> <span>${this.title}</span></p>
                        </div>
                        <div class="lg:mt-w30p mt-w24p lg:px-w60p text-center lg:text-18p lg:leading-w28p text-16p leading-w20p font-normal text-body wysiwyg">
                            ${this.description}
                        </div>
                        <div class="lg:mt-w40p mt-w24p w-auto leading-none text-center"><a class="text-shadow-primary lg:px-w48p lg:py-w12p px-w30p py-w10p lg:text-32p lg:leading-w50p text-20p leading-w32p font-bold bg-main text-white lg:rounded-w20p rounded-w20p lg:border-8p border-4p border-main-light inline-flex justify-center items-center text-center" href="${this.button.link}"><span>${this.button.text}</span></a></div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        `;

        this.el = document.createElement("div");
        this.el.innerHTML = html;
        document.body.appendChild(this.el);
        this.popup = this.el.querySelector(".popup-success");

        this.show(this.popup);
    }

    show(popup) {
        requestAnimationFrame(() => {
            popup.classList.add("is-showed");
            this.addEvents(popup);
        });
    }

    hide(popup) {
        popup.classList.remove("is-showed");

        setTimeout(() => {
            this.el.remove();
        }, 300);
    }

    addEvents(popup) {
        const closesPopup = popup.querySelectorAll('.close');
        closesPopup?.forEach((close) => {
            // close.addEventListener('click', () => this.hide(popup))
            close.addEventListener('click', () => window.location.reload())
        })

    }
}

export default BraneyPopup;
